import React from 'react'
import { useTranslation } from 'react-i18next'
import { Highlight, Icon } from '@node-space/ui-components'
import {
  customerDocumentStatusHighlight,
  customerStatusHighlight,
  customerTypeHighlight,
} from 'pages/EmbeddedCustomers/helpers/mappings'
import { EmbeddedCustomerStatus } from 'pages/EmbeddedCustomers/helpers/types'
import {
  getCustomerDocumentStatusLabel,
  getCustomerStatusLabel,
  getCustomerTypeLabel,
} from 'pages/EmbeddedCustomers/helpers/utils'
import { StatusLabelMapping } from 'pages/NestedCustomers/constants'
import {
  CustomerDocumentStatus,
  CustomerDocumentStatusType,
  CustomerEntityType,
  CustomerStatus,
  CustomerStatusType,
} from 'types/customers'

export interface CustomerTypeHighlightProps {
  type: CustomerEntityType
}
export const CustomerTypeHighlight = ({ type }: CustomerTypeHighlightProps) => {
  const { t } = useTranslation()
  return (
    <Highlight
      iconElement={
        <Icon
          name={type === CustomerEntityType.COMPANY ? 'BuildingOffice' : 'UserCircle'}
          size="small"
        />
      }
      variant="emphasis"
      {...(customerTypeHighlight?.[type] && { type: customerTypeHighlight?.[type] })}
    >
      {getCustomerTypeLabel(type, t)}
    </Highlight>
  )
}

export const EmbeddedCustomerStatusHighlight = ({ status }: { status: EmbeddedCustomerStatus }) => {
  const { t } = useTranslation()
  return (
    <Highlight
      {...(customerStatusHighlight?.[status] && { type: customerStatusHighlight?.[status] })}
    >
      {getCustomerStatusLabel(status, t)}
    </Highlight>
  )
}

export const NestedCustomerStatusHighlight = ({ status }: { status: CustomerStatusType }) => {
  if (status !== CustomerStatus.VERIFIED) {
    return <Highlight type="warning">{StatusLabelMapping[status]}</Highlight>
  }
  return null
}

export const CustomerDocumentStatusHighlight = ({
  status,
  isUploaded,
}: {
  status: CustomerDocumentStatusType
  isUploaded: boolean
}) => {
  const { t } = useTranslation()
  const type = customerDocumentStatusHighlight?.[status]

  if (status === CustomerDocumentStatus.APPROVED) return null
  if (!isUploaded)
    return (
      <Highlight type="warning">{t('embeddedCustomers.documentStatus.infoRequired')}</Highlight>
    )

  return (
    <Highlight
      {...(type && {
        type,
      })}
    >
      {getCustomerDocumentStatusLabel(status, t)}
    </Highlight>
  )
}
